import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

export const TransferstationManagementStore = create((set, get) => ({
  transferstationManagementReportData: [],
  loading: false,
  error: null,
  currentFilters: null,

  fetchTransferstationManagementReport: async (queryParams) => {
    set({ loading: true, error: null, currentFilters: queryParams });

    // Persist latest filters
    try {
      localStorage.setItem(
        "transferstationMonthlyFilters",
        JSON.stringify(queryParams)
      );
    } catch (e) {
      console.error("Failed to persist transferstation filters", e);
    }

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const transferstationManagementReport = await apiCall({
        url: `${API_BASE_URL1}GVPReports/KPI10TransferStation?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      // Handle different response structures
      let dataArray = [];

      if (Array.isArray(transferstationManagementReport)) {
        dataArray = transferstationManagementReport;
      } else if (
        transferstationManagementReport &&
        Array.isArray(transferstationManagementReport.data)
      ) {
        dataArray = transferstationManagementReport.data;
      } else if (
        transferstationManagementReport &&
        typeof transferstationManagementReport === "object"
      ) {
        dataArray = [transferstationManagementReport];
      }

      set({
        transferstationManagementReportData: dataArray,
        loading: false,
        error: null,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;


      // 🔐 401 Unauthorized
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          transferstationManagementReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      // ⚠️ 400 Bad Request
      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          transferstationManagementReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      // 📭 404 Not Found
      else if (status === 404) {
        toast.error(error.message );
        set({
          transferstationManagementReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      // 🔴 500 Internal Server Error
      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          transferstationManagementReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      // ❓ Other Errors
      else {
        toast.error(message || "Something went wrong");
        set({
          transferstationManagementReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }

    } finally {
      set({ loading: false });
    }
  },
}));
